export enum MotivoIsencaoFiscal {
  TAXI = "TAXI",
  FROTISTA = "FROTISTA",
  PCD = "PCD",
  ZONA_FRANCA_MANAUS = "ZONA_FRANCA_MANAUS",
  OUTROS = "OUTROS",
}
